package com.example.hukakmp.viewmodel

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.example.hukakmp.data.PescadexRepository
import com.example.hukakmp.model.EspecieConEstado
import com.example.hukakmp.model.EstadisticasPescadex
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

class PescadexViewModel(
    private val repository: PescadexRepository,
) : ViewModel() {

    data class UiState(
        val isLoading: Boolean = true,
        val especies: List<EspecieConEstado> = emptyList(),
        val estadisticas: EstadisticasPescadex = EstadisticasPescadex(),
        val error: String? = null,
    )

    private val _uiState = MutableStateFlow(UiState())
    val uiState: StateFlow<UiState> = _uiState.asStateFlow()

    init {
        refresh()
    }

    fun refresh() {
        viewModelScope.launch {
            _uiState.value = _uiState.value.copy(isLoading = true, error = null)
            try {
                val especies = repository.obtenerEspeciesConEstado()
                val stats = EstadisticasPescadex(
                    especiesDescubiertas = especies.count { it.esCapturada },
                    totalEspecies = especies.size,
                    totalCapturas = especies.sumOf { it.datosCaptura?.totalCapturas ?: 0 },
                )
                _uiState.value = UiState(
                    isLoading = false,
                    especies = especies,
                    estadisticas = stats,
                )
            } catch (e: Exception) {
                _uiState.value = UiState(
                    isLoading = false,
                    error = e.message ?: "No se pudo cargar tu Pescadex.",
                )
            }
        }
    }
}
